import React, { useEffect, useState } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Icon } from "@iconify/react";
import { getBooksDetail } from "../../api/bookService";
import bookimg1 from "../../assets/img/bookimg1.jpg"; // fallback image

const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net"; // ✅ Use same as BooksInfo

export default function Viewbook() {
  const { bookId } = useParams();
  const [book, setBook] = useState(null);
  const [showDelete, setShowDelete] = useState(false);
  const [characterModal, setCharacterModal] = useState(false);

  const fetchBookData = async () => {
    try {
      const response = await getBooksDetail({ bookId });
      console.log('===bookdetail===response',response)
      if (response.status && response.data.length > 0) {
        setBook(response.data[0]);
      }
    } catch (error) {
      console.error("Failed to fetch book details", error);
    }
  };

  useEffect(() => {
    fetchBookData();
  }, [bookId]);

  const columns = [
    {
      name: 'SR No.',
      width: '80px',
      cell: (row, index) => index + 1,
    },
    {
      name: 'Cover',
      width: '100px',
      cell: row => (
        <img
          className="table_img rounded img-thumbnail"
          src={row.file ? `${MEDIA_URL}/${row.file}` : bookimg1}
          alt="Chapter cover"
          width={50}
          height={50}
        />
      ),
    },
    {
      name: 'Title',
      minWidth: '200px',
      selector: row => row.title,
      cell: row => row.title || "N/A",
    },
    {
      name: 'Chapter',
      width: '100px',
      selector: row => row.chapterNumber,
    },
    {
      name: "Actions",
      width: "150px",
      cell: row => (
        <>
          <Link className="btnview" to={`/books/chapter-details/${row._id}`}>
            <Icon icon="tabler:eye" />
          </Link>
          {/* <span className="btndelete" onClick={() => setShowDelete(true)}>
            <Icon icon="tabler:trash" />
          </span> */}
        </>
      ),
    },
  ];

  if (!book) {
    return <p className="text-center mt-5">Loading book details...</p>;
  }

  // Sort chapters by chapter number in ascending order
  const sortedChapters = [...(book.chapters || [])].sort((a, b) => {
    return (a.chapterNumber || 0) - (b.chapterNumber || 0);
  });

  return (
    <>
      <Card>
        <Card.Header className="d-flex align-items-center justify-content-between">
          <h5>Book Details</h5>
          <Button as={Link} to="/books" className="btn btn-primary-light px-4 min_width140">
            Back
          </Button>
        </Card.Header>

        <Card.Body className="taledtl_div mt-3">
          <Row className="g-3 mb-4">
            <Col md="4">
              <div className="talefile_box">
                <img
                  className="talefile_img"
                  src={book.coverImage ? `${MEDIA_URL}/${book.coverImage}` : bookimg1}
                  alt="Book Cover"
                />
              </div>
            </Col>
            <Col md="8">
              <div className="talefile_list">
                <div className="tablefilelist_grid">
                  <h4>Title</h4>
                  <p>{book.title}</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Main Theme</h4>
                  <p>{book.mainTheme}</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Characters</h4>
                  <p>
                    <Link onClick={() => setCharacterModal(true)}>
                      {book.characterCount}
                    </Link>
                  </p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Date</h4>
                  <p>{new Date(book.createdAt).toLocaleDateString()}</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Theme</h4>
                  <p>{book.briefSummary}</p>
                </div>
              </div>
            </Col>
          </Row>
          {book.chapters && book.chapters.length>0 &&(
            <>
             <div className="headinner">
            <h4 className="fw-bold">Chapters</h4>
          </div>
          <div className="card_body_padding">
            <DataTable
              columns={columns}
              data={sortedChapters}
              pagination
              highlightOnHover
              responsive
              noDataComponent="No chapters found"
              className="table_common"
            />
          </div>
            </>
          )
          
          }

         
        </Card.Body>
      </Card>

      {/* Delete Confirmation Modal */}
      <Modal className="modal_Delete" show={showDelete} onHide={() => setShowDelete(false)} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o" />
            <h3>Are You Sure?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button onClick={() => setShowDelete(false)} className="btn btn-primary-outline px-4 me-3">
            Cancel
          </Button>
          <Button className="btn btn-primary px-4 min_width110" onClick={() => setShowDelete(false)}>
            Ok
          </Button>
        </Modal.Body>
      </Modal>

      {/* Characters Modal */}
      <Modal className="modal_likes" show={characterModal} onHide={() => setCharacterModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>
      <h2 className="modalhead">Characters</h2>
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="talelike_div">
      {book.characters && book.characters.length > 0 ? (
        book.characters.map((char, index) => (
          <div className="talelike_box" key={char._id || index}>
            <img
              className="img-thumbnail"
              src={char.character_image ? `${MEDIA_URL}/${char.character_image}` : bookimg1}
              alt={char.character_name || "Character"}
            />
            <h4>{char.character_name || "N/A"}</h4>
          </div>
        ))
      ) : (
        <p className="text-center w-100 py-4">No data found</p>
      )}
    </div>
  </Modal.Body>
</Modal>
    </>
  );
}
